// @generated by protoc-gen-es v2.9.0 with parameter "target=ts"
// @generated from file squareup/cash/moneta/core/model/transfer_rail.proto (package squareup.cash.moneta.core.model.rails, syntax proto2)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file squareup/cash/moneta/core/model/transfer_rail.proto.
 */
export const file_squareup_cash_moneta_core_model_transfer_rail: GenFile = /*@__PURE__*/
  fileDesc("CjNzcXVhcmV1cC9jYXNoL21vbmV0YS9jb3JlL21vZGVsL3RyYW5zZmVyX3JhaWwucHJvdG8SJXNxdWFyZXVwLmNhc2gubW9uZXRhLmNvcmUubW9kZWwucmFpbHMqVgoMVHJhbnNmZXJSYWlsEgkKBURFQklUEAASBwoDQUNIEAESDQoJQVBQTEVfUEFZEAISDgoKR09PR0xFX1BBWRADEgoKBkNSRURJVBAEEgcKA1JGUBAFQlIKKWNvbS5zcXVhcmV1cC5jYXNoLm1vbmV0YS5jb3JlLm1vZGVsLnJhaWxzWiVzcXVhcmV1cF9jYXNoX21vbmV0YV9jb3JlX21vZGVsX3JhaWxz");

/**
 * @generated from enum squareup.cash.moneta.core.model.rails.TransferRail
 */
export enum TransferRail {
  /**
   * @generated from enum value: DEBIT = 0;
   */
  DEBIT = 0,

  /**
   * @generated from enum value: ACH = 1;
   */
  ACH = 1,

  /**
   * @generated from enum value: APPLE_PAY = 2;
   */
  APPLE_PAY = 2,

  /**
   * @generated from enum value: GOOGLE_PAY = 3;
   */
  GOOGLE_PAY = 3,

  /**
   * @generated from enum value: CREDIT = 4;
   */
  CREDIT = 4,

  /**
   * Cash-in funded by an RTP Request for Payment: the customer authorizes the payment in their own
   * bank's app and their bank sends an inbound RTP credit.
   *
   * @generated from enum value: RFP = 5;
   */
  RFP = 5,
}

/**
 * Describes the enum squareup.cash.moneta.core.model.rails.TransferRail.
 */
export const TransferRailSchema: GenEnum<TransferRail> = /*@__PURE__*/
  enumDesc(file_squareup_cash_moneta_core_model_transfer_rail, 0);

